const RequiredContextValue = require("../classes/required-context-value");
const { entityScopeFromBindings } = require("./component-binding-scope");

const ELEMENT_STORY_ENTITY_TYPE = "Story";
const ELEMENT_STORY_APP_NAME = "Legacy";

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function elementStoryContext(elementStoryId) {
  return {
    entityType: ELEMENT_STORY_ENTITY_TYPE,
    entityPkUrlVars: { id: elementStoryId },
    entitySource: "context",
    appName: ELEMENT_STORY_APP_NAME,
  };
}

function completionCardScope({ stateBindings, required, elementStoryContextName, elementStoryId, lookupSourceContext }) {
  const bindings = isPlainObject(stateBindings) ? stateBindings : {};
  const requiredMap = isPlainObject(required) ? required : {};
  const lookup = sourceName => {
    if (sourceName === elementStoryContextName) {
      return elementStoryId ? elementStoryContext(elementStoryId) : null;
    }
    return lookupSourceContext(sourceName) ?? null;
  };
  const scoped = entityScopeFromBindings({ bindings, required: requiredMap, lookupSourceContext: lookup });
  const unresolved = Object.keys(requiredMap)
      .filter(name => {
        const binding = bindings[name];
        if (scoped[name] !== undefined || RequiredContextValue.isPrimitiveBinding(binding)) {
          return false;
        }
        return typeof binding === "string" && binding !== "";
      })
      .map(name => ({ name, source: bindings[name] }));
  const storyContextName = Object.keys(requiredMap)
      .find(name => bindings[name] === elementStoryContextName) ?? "";
  return { scoped, unresolved, storyContextName };
}

module.exports = { completionCardScope, elementStoryContext };
